var Region = {
  EuropeWithoutGBIE: 'en-CEU',
  Asia: 'en-CAS',
  Pacific: 'en-PAC',
  NorthAm: 'en-NAM',
  SouthAm: 'pt_BR-LAM',
  GBIE: 'en-UKI'
};
export default Region;